module.exports = __webpack_public_path__ + "static/img/6.84611b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/district/assets/image/home/6.png
// module id = 2MHK
// module chunks = 3